import React from 'react'
import { withComponent } from 'react-emotion'
import Img from 'gatsby-image'

import MarkdownContent from '../components/MarkdownContent'
import { Box, Text } from './Layout'
import { Paragraph } from './Typography'
import { GithubLink, WebsiteLink } from './SocialLinks.js'

const ProjectPreview = ({ project, level, ...props }) => {
  const Content = MarkdownContent.withComponent('main')
  const ProjectTitle = Text.withComponent(level)
  const DescriptionComponent = project.frontmatter.description ? (
    <Text color="black">{project.frontmatter.description}</Text>
  ) : (
    ''
  )
  const Image = project.frontmatter.image ? (
    <Img sizes={project.frontmatter.image.childImageSharp.sizes} />
  ) : (
    ''
  )

  return (
    <Box {...props}>
      <Box display={['block', 'none']} width={1 / 5}>
        <Paragraph
          fontSize={[2, 3]}
          fontWeight={7}
          lineHeight="title"
          mt={0}
          mb={2}
        >
          {project.frontmatter.title}
          &nbsp;
          {project.frontmatter.repo ? (
            <GithubLink repo={project.frontmatter.repo} />
          ) : (
            ''
          )}
          &nbsp;
          {project.frontmatter.website ? (
            <WebsiteLink link={project.frontmatter.website} />
          ) : (
            ''
          )}
        </Paragraph>
      </Box>
      <Paragraph fontSize={[2, 3]} lineHeight="copy" mt={0} mb={2}>
        {DescriptionComponent}
      </Paragraph>
      <Paragraph fontSize={[1, 2]} lineHeight="copy" mt={3} mb={2}>
        {Image}
      </Paragraph>
      <Paragraph fontSize={[1, 2]} lineHeight="copy" mt={3} mb={2}>
        <Content
          lineHeight="copy"
          fontSize={[1, 2]}
          dangerouslySetInnerHTML={{ __html: project.html }}
        />
      </Paragraph>
    </Box>
  )
}

export default ProjectPreview



// WEBPACK FOOTER //
// ./src/components/ProjectPreview.js